import { CreateApiKeyDto } from '@/view/pages/api-keys/models/CreateApiKeyDto';

export class UpdateApiKeyDto extends CreateApiKeyDto {
  constructor(data) {
    super(data);
    this.id = data.id;
  }
}
